import { useDataFetchingClient } from 'data-fetching-client';
import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedPhoneNumber from 'I18n/components/FormattedPhoneNumber';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { GET_CHECKOUT_SESSION } from '../../data/queries';

/*
  A component used to signal that an error happened on our side. This includes
  client side runtime errors, 500s, or any other unexpected error states
*/
import { jsx as _jsx } from "react/jsx-runtime";
export default function FullPageError() {
  const client = useDataFetchingClient();
  const queryData = client.readQuery({
    query: GET_CHECKOUT_SESSION
  });
  const checkoutSession = queryData === null || queryData === void 0 ? void 0 : queryData.checkoutSession;
  let messageOptionsAvailable = false;
  let messageOptions = {};

  // if the checkoutSession available, we have a way to display contact info on error page.
  if (checkoutSession) {
    var _checkoutSession$user, _checkoutSession$comp, _checkoutSession$comp2;
    const companyName = (_checkoutSession$user = checkoutSession.userDefinedBranding) === null || _checkoutSession$user === void 0 ? void 0 : _checkoutSession$user.companyName;
    const email = (_checkoutSession$comp = checkoutSession.companyDetails) === null || _checkoutSession$comp === void 0 ? void 0 : _checkoutSession$comp.supportEmail;
    const phone = (_checkoutSession$comp2 = checkoutSession.companyDetails) === null || _checkoutSession$comp2 === void 0 ? void 0 : _checkoutSession$comp2.supportPhone;
    messageOptionsAvailable = Boolean(companyName && email && phone);
    messageOptions = {
      href: window.location.href,
      companyName,
      email,
      phone
    };
  }
  // Show merchant contact info if available
  const message = messageOptionsAvailable ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "payments.errorState.genericErrorWithContactInfo_jsx",
    options: messageOptions,
    elements: {
      Link,
      Phone: FormattedPhoneNumber
    }
  }) : /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "payments.errorState.genericError_jsx",
    options: {
      href: window.location.href
    },
    elements: {
      Link
    }
  });

  // https://product.hubteam.com/docs/frontend/docs/react-rhumb.html#error-boundaries-and-repeatable-errors
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "RHUMB_GLOBAL_ERROR",
    children: /*#__PURE__*/_jsx(ErrorMessage, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payments.errorState.errorTitle"
      }),
      children: /*#__PURE__*/_jsx("p", {
        children: message
      })
    })
  });
}